import { put, select } from 'redux-saga/effects'

import { track as trackEvent } from '../../actions/tracking'
import { selectProduct } from '../../selectors/product'
import { selectCurrentCollectionIndex } from '../../selectors/ux'

function* onProductVideoEnterFullscreen(action) {
  const { params: { productId } } = action.payload

  const product = yield select(selectProduct(productId))
  const position = (yield select(selectCurrentCollectionIndex)) + 1 // from 1 to N

  yield put(trackEvent({
    event: 'toggleView',
    params: {
      view: 'full',
      id: product.id,
      title: product.title,
      position,
    },
  }))
}

export default onProductVideoEnterFullscreen
